import { HERO_MOCKUP, IMAGE_ORIGIN } from '../data/welding'
import { FACEBOOK_DOMAIN_VERIFICATION } from '../data/analytics'

interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

const PAGE_TITLE = 'PLANS DE SOUDURE™ — 30 plans de fabrication d’équipements d’atelier pour soudeurs'

const META_TAGS: MetaTag[] = [
  {
    // Fit the device width at 1×, never zoom out below it; browser zoom-in
    // stays available for accessibility (no maximum-scale / user-scalable=no).
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, minimum-scale=1, viewport-fit=cover',
  },
  {
    name: 'description',
    content:
      'PLANS DE SOUDURE™ : 30 projets d’équipement d’atelier en 6 volumes PDF — cotes en mm et en pouces, listes de débit, vues techniques et séquences de fabrication. Plus 5 bonus offerts.',
  },
  ...(FACEBOOK_DOMAIN_VERIFICATION
    ? [{ name: 'facebook-domain-verification', content: FACEBOOK_DOMAIN_VERIFICATION }]
    : []),
]

const LINK_TAGS: LinkTag[] = [
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: IMAGE_ORIGIN },
  // The hero product mockup is the LCP element.
  { rel: 'preload', href: HERO_MOCKUP.src, as: 'image', fetchPriority: 'high' },
]

/** Inserts global <meta> and resource-hint <link> tags into <head> once. */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE
  document.documentElement.lang = 'fr'
  // Remove any stale verification tag from the previous product.
  if (!FACEBOOK_DOMAIN_VERIFICATION) {
    document.querySelector('meta[name="facebook-domain-verification"]')?.remove()
  }

  META_TAGS.forEach(({ name, content }) => {
    const existing = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
    if (existing) {
      existing.content = content
      return
    }
    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
